// removed by extract-text-webpack-plugin
module.exports = {"box":"_4cw329gbequ7kw226e5nm81c4xhd6gp9pzf36eaqevsze1k6sz4axucdu53ej32sk6teqwytecbm68wkgafetfdtfuvb9e7e7rz7xrt-styles-module-box","text":"_2juv9tw9r9jfwbcp7w7z4ux42amwdkhjurr4pg1h4n4gzqmzazbf681mq9kx4nkusrh2a4we2gubdr4e5n681w3k4xpzphvmme7w6xg-styles-module-text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Label/styles.module.sass
// module id = 542
// module chunks = 0